import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PalantirContentComponent } from './palantir-content.component';

@NgModule({
  declarations: [
    PalantirContentComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PalantirContentComponent
  ]
})
export class PalantirContentModule { }
